export default __webpack_public_path__ + "static/media/proj-01.8bae98dd.png";